import React from "react";
import { Link, NavLink } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <footer className="d-block d-lg-none  d-md-none d-xl-none  position-fixed  w-100  bottom-0  start-0 ">
        <svg
          width="100%"
          height="107"
          viewBox="0 0 746 167"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-28.0539 1.46564H256.032C277.483 1.46564 297.959 10.4303 312.509 26.1927C342.286 58.4515 392.691 60.1333 424.553 29.9314L430.146 24.6296C445.836 9.75608 466.633 1.46564 488.253 1.46564H772.357V291.32H-28.0539V1.46564Z"
            fill="white"
            stroke="#EEF1F5"
            strokeWidth="2.89222"
          />
        </svg>

        <div className="position-absolute top-0  start-0 h-100 w-100">
          <div className="add-list position-absolute start-50  translate-middle  d-flex  justify-content-center  align-items-center ">
            <Link to="/addlead">
              <i className="fa-solid fa-circle-plus "></i>
            </Link>
          </div>
          <ul className=" d-flex mb-0 justify-content-around ps-0 align-items-center h-100">
            <li>
              <NavLink
                to="/"
                className="nav-link d-flex flex-column pt-3  justify-content-center    align-items-center"
              >
                <i className="fa-solid fa-house"></i>Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/managelead"
                className="nav-link d-flex flex-column pt-3 justify-content-center   align-items-center"
              >
                <i className="fa-solid fa-folder"></i>Lead
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/followup"
                className="nav-link ps-4 pt-3 d-flex flex-column justify-content-center   align-items-center"
              >
                <i className="fa-solid fa-list"></i>Follow up
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/calender"
                className="nav-link d-flex flex-column pt-3 justify-content-center  align-items-center  "
              >
                <i className="fa-solid fa-calendar"></i>Calender
              </NavLink>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Footer;
